import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberForm from '../../../components/forms/MemberForm';
import { MemberClient, MemberDTO } from '../../../services/apiClient';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../../config/config';
import Card from '../../../components/common/Card';
import axiosInstance from '../../../services/axiosInstance';
import { showToast } from '../../../utils/showToast';

const MemberCreate: React.FC = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const apiClient = new MemberClient(API_BASE_URL, axiosInstance);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Members', href: '/admin/members' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: MemberDTO) => {
    setIsSubmitting(true);
    try {
      var response = await apiClient.createMember(data);
      if(response.success){
        showToast('Member was created successfully', 'success');
        navigate('/admin/members');
      }else{
        showToast('Error creating member', 'error');
      }
    } catch (error) {
      console.error('Error creating Member:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      title="Create Member"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Administrator']}
    >
      <Card>
        <MemberForm
          initialValues={{} as MemberDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/members')}
        />
      </Card>
    </AdminLayout>
  );
};

export default MemberCreate;
